// Video tutorial mapping: route path → array of { id, title, description }
// To add real videos: replace 'PLACEHOLDER' with the YouTube video ID
// from https://www.youtube.com/@EzeitPro
// e.g. for https://www.youtube.com/watch?v=dQw4w9WgXcQ, the id is 'dQw4w9WgXcQ'

export const HELP_VIDEOS = {
  '/dashboard': [
    {
      id: 'HkSNeh7EDGQ',
      title: 'Dashboard Overview',
      description: 'Learn how to navigate your dashboard and understand key metrics.',
    },
  ],
  '/vendor_bookings': [
    {
      id: 'UiKY5ivkcsI',
      title: 'Managing Bookings',
      description: 'Create, view, and manage bookings from your calendar.',
    },
  ],
  '/providers': [
    {
      id: '-Stjn4iNCFA',
      title: 'Managing Your Crew',
      description: 'Add, edit, and manage your crew members and doctors.',
    },
  ],
  '/add_offerings': [
    {
      id: 'U6b7r2sBNFg',
      title: 'Admin Setup Guide',
      description: 'Configure your services, offerings, and business settings.',
    },
  ],
  '/subscription': [
    {
      id: 'fgDi9Pn5BFo',
      title: 'Subscription Plans',
      description: 'Understand and manage your subscription options.',
    },
  ],
  '/analytics': [
    {
      id: 'ncGB28ZLN5M',
      title: 'Analytics & Insights',
      description: 'Track your business performance with detailed analytics.',
    },
  ],
  '/channel': [
    {
      id: 'PLACEHOLDER',
      title: 'Channels & Chat',
      description: 'Communicate with clients using messaging channels.',
    },
  ],
  '/setup': [
    {
      id: '18irR06l5G8',
      title: 'Getting Started',
      description: 'Complete your profile and initial business setup.',
    },
  ],
  '/vendors/view-profile': [
    {
      id: 'fSQhxWvMEIM',
      title: 'Managing Your Profile',
      description: 'Update your business profile and branding.',
    },
  ],
  _general: [
    {
      id: 'HkSNeh7EDGQ',
      title: 'Platform Overview',
      description: 'A full walkthrough of EzeitPro features.',
    },
  ],
};

export const getVideosForRoute = (pathname) => {
  return HELP_VIDEOS[pathname] || [];
};

export const getAllVideos = () => {
  return Object.entries(HELP_VIDEOS)
    .filter(([key]) => key !== '_general')
    .flatMap(([, videos]) => videos)
    .concat(HELP_VIDEOS._general);
};
